import React from 'react';
import { transform } from '@babel/core';
import Common from "../../Models/Common";
class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <img src={Common.baseUrl+this.props.img}
                style={{ width: '100%', height: '60%', objectFit: 'cover' }}
            />

        )
    }
}
export { Image }
